import styles from "./styles.module.css";
import PropTypes from 'prop-types';

const FormFieldLayout = ({
  children,
  type,
  deepDisable,
  formType,
  name,
  label,
  rules,
  value,
}) => {

  const getContainerClassNames = () => {
    const classes = [styles["container"]];
    if (type === "radio") classes.push(styles["container-radio"]);
    if (type === "select") classes.push(styles["container-select"]);
    if (deepDisable) classes.push(styles["deep-disable"]);
    return classes.join(" ");
  };

  const getLabelClassNames = () => {
    const classes = [];
    if (type === "textarea" || formType === "create") {
      classes.push(styles["create-label"]);
    }
    if (formType === "coco") {
      classes.push(styles["coco-label"]);
    }
    return classes.join(" ");
  };

  return (
    <div className={getContainerClassNames()}>
      <label className={getLabelClassNames()} htmlFor={name}>
        {label}
        {rules?.required && (
          <span className={styles["label-star"]}>
            *{" "}
            {rules?.hasSubmitted && (!value?.trim() || rules?.hasError) && (
              <span className={styles["label-reuired"]}>
                {rules?.message || "Required"}
              </span>
            )}
          </span>
        )}
      </label>
      {children}
    </div>
  );
};
FormFieldLayout.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['text', 'textarea', 'radio', 'select']),
  deepDisable: PropTypes.bool,
  formType: PropTypes.oneOf(['create', 'coco']),
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.shape({
    required: PropTypes.bool,
    hasSubmitted: PropTypes.bool,
    hasError: PropTypes.bool,
    message: PropTypes.string,
  }),
  value: PropTypes.string,
};

export default FormFieldLayout;